import React, { FC, useState } from 'react';
// import { useTranslation } from 'react-i18next';
// import useAPIError from '../../hooks/useAPIError';
// import { useAuthStore } from '../../store/AuthContext';
// import { useAppStore } from '../../store/AppContext';
import { useTranslation } from 'react-i18next';
import clubMasterCardOro from '../../../assets/images/club-master-oro.png';
import TarjetaForm from './form/solicitudTarjetaForm';
import AdicionalModal from './form/adicionalModal';

const TitularOroTpecCaprabo: FC = () => {
  // const { t } = useTranslation();
  // const dataUser = useAuthStore();
  // const dataApp = useAppStore();
  // const { addError, addErrorBack } = useAPIError();
  const { t } = useTranslation();
  const [showSolicitud, setShowSolicitud] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);

  // useEffect(() => {
  //   if (dataUser.user.token !== '') retrieveSaldo();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [i18n.language]);
  return (
    <>
      <section className="header-tarjetas tarjetas">
        <div className="container">
          <div className="header-tarjetas__content">
            <h1 className="header-tarjetas__title">Tarjetas</h1>
            <div className="bloque-etiquetas">
              <span className="etiqueta">Eroski Club</span> +{' '}
              <span className="etiqueta oro">Tarjeta oro</span> +{' '}
              <span className="etiqueta">Tarjeta de crédito</span>
            </div>
            <p>
              Tu número de socio <strong>601547029</strong>
            </p>
          </div>
        </div>
      </section>

      <section className="o-section--giant__top u-padding-bottom-hero section--background-color tarjetas">
        <div className="container-inner">
          <div className="grupo-tarjetas">
            <div className="img-tarjeta">
              <img
                src={clubMasterCardOro}
                alt="Tarjeta Eroski Club, Tarjeta oro y tarjeta mastercard"
              />
            </div>
          </div>

          <div className="tarjeta__content">
            <h2 className="bloque-datos__title">
              <span className="divider__square brand-color" />
              <span className="u-margin-right">Club Caprabo</span>
            </h2>

            <div className="u-display-flex-tablet u-justify-content-space-between">
              <div className="bloque-socio">
                <p className="title__medium u-margin-bottom-small">
                  ¿No dispones de tu tarjeta?
                </p>
                <p className="u-margin-bottom-medium">
                  Descargar{' '}
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="" className="link link-demi">
                    tarjeta temporal
                  </a>
                </p>

                <p className="title__medium u-margin-bottom-small">
                  ¿Quiéres añadir algún adicional?
                </p>
                <p>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                  <a
                    onClick={() => {
                      setShowSolicitud(true);
                      document.body.classList.add('fix');
                    }}
                    className="link link-demi open-solicitar"
                  >
                    Añadir adicional
                  </a>
                </p>
              </div>
              <div className="bloque-socio">
                <form method="post">
                  <fieldset>
                    <legend className="title__medium u-margin-bottom-small">
                      ¿Necesitas otra tarjeta para ti o tu familia?
                    </legend>
                    <ul className="u-margin-bottom-medium">
                      <li className="u-margin-bottom">
                        <div className="radio radio-inline">
                          <input
                            type="radio"
                            id="tarjetafisica"
                            value="perdida"
                            name="necesitastarjeta"
                            className="form-control"
                          />
                          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                          <label htmlFor="perdida" className="control-label">
                            {t('caprabo.tarjetas.need-option-cero')}
                          </label>
                        </div>
                      </li>
                      <li className="u-margin-bottom">
                        <div className="radio radio-inline">
                          <input
                            type="radio"
                            id="perdida"
                            value="perdida"
                            name="necesitastarjeta"
                            className="form-control"
                          />
                          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                          <label htmlFor="perdida" className="control-label">
                            Si, la he perdido o está estropeada
                          </label>
                        </div>
                      </li>
                      <li className="u-margin-bottom">
                        <div className="radio radio-inline">
                          <input
                            type="radio"
                            value="familia"
                            id="familia"
                            name="necesitastarjeta"
                            className="form-control"
                          />
                          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                          <label htmlFor="familia" className="control-label">
                            Si, la quiero para un familiar
                          </label>
                        </div>
                      </li>
                    </ul>
                    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                    <span
                      className="link link-demi"
                      onClick={() => setShowModal(true)}
                    >
                      Solicitar
                    </span>
                  </fieldset>
                </form>
              </div>{' '}
            </div>
            <div className="divider small" />

            <h2 className="bloque-datos__title">
              <span className="divider__square brand-gold-color" />
              <span className="u-margin-right">Tarjeta Oro</span>
            </h2>

            <div className="u-display-flex-tablet u-justify-content-space-between">
              <div className="bloque-socio">
                <p className="title__medium u-margin-bottom-small">
                  ¿Quieres cambiar de cuota?
                </p>
                <p>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="" className="link link-oro link-demi">
                    Cambiar
                  </a>
                </p>
              </div>

              <div className="bloque-socio">
                <p className="title__medium u-margin-bottom-small">
                  ¿Quiéres hacer otras gestiones
                </p>
                <p>
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="" className="link link-oro link-demi">
                    Gestionar
                  </a>
                </p>
              </div>
            </div>
            <div className="divider small" />

            <h2 className="bloque-datos__title">
              <span className="divider__square brand-color" />
              <span className="u-margin-right">Tarjeta de crédito</span>
            </h2>

            <div className="u-display-flex-tablet u-justify-content-space-between">
              <div className="bloque-socio">
                <p className="title__medium u-margin-bottom-small">
                  ¿Quieres consultar tus movimientos?
                </p>
                <p>
                  Ir a {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a href="" className="link link-demi">
                    consultas y gestiones
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <TarjetaForm visible={showSolicitud} setVisible={setShowSolicitud} />
      <AdicionalModal visible={showModal} setVisible={setShowModal} />
    </>
  );
};

export default TitularOroTpecCaprabo;
